import { c as _c } from "react/compiler-runtime";
import { cva, cx } from 'class-variance-authority';
import { motion } from 'framer-motion';
export type ToggleGroupOption = {
  value: string;
  label: string;
  count?: number;
  hasMore?: boolean;
  countLoading?: boolean;
};
export type ToggleGroupProps = {
  'aria-label'?: string;
  options: ToggleGroupOption[];
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
  groupId?: string;
};
const badgeStyles = cva(cx('text-label-3 items-center inline-flex justify-center', 'min-w-[20px] h-[calc(100%-4px)] py-0.5 px-1 rounded-[calc(var(--filter-pill-radius)-5px)]'), {
  variants: {
    selected: {
      true: cx('text-quinary', '[background:linear-gradient(0deg,rgba(255,255,255,0.1)_0%,rgba(255,255,255,0.1)_100%),var(--background-color-accent)]'),
      false: 'bg-secondary text-quaternary'
    },
    disabled: {
      true: 'bg-transparent text-quaternary [background:none]',
      false: ''
    }
  },
  defaultVariants: {
    selected: false,
    disabled: false
  }
});
const ToggleGroup = t0 => {
  const $ = _c(20);
  const {
    "aria-label": ariaLabel,
    options,
    value,
    onChange,
    disabled,
    groupId
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== value) {
    t1 = option => {
      if (disabled) {
        return "disabled";
      }
      if (value === option.value) {
        return "selected";
      }
      return "unselected";
    };
    $[0] = disabled;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAnimate = t1;
  let t2;
  if ($[3] !== disabled || $[4] !== getAnimate || $[5] !== groupId || $[6] !== onChange || $[7] !== options || $[8] !== value) {
    let t3;
    if ($[10] !== disabled || $[11] !== getAnimate || $[12] !== groupId || $[13] !== onChange || $[14] !== value) {
      t3 = option_0 => {
        const isSelected = value === option_0.value;
        return <div className="relative flex items-center justify-center h-full" key={option_0.value}><motion.button type="button" disabled={disabled} data-selected={isSelected} onClick={() => onChange?.(option_0.value)} variants={{
            selected: {
              color: "var(--text-color-quinary)"
            },
            unselected: {
              color: "var(--text-color-primary)"
            },
            disabled: {
              color: "var(--text-color-quaternary)"
            }
          }} initial={false} animate={getAnimate(option_0)} className={cx("text-label-3 border-none h-full", "flex items-center justify-center gap-1 px-3 rounded-[calc(var(--filter-pill-radius)-3px)]", "z-1 relative cursor-pointer", "disabled:cursor-not-allowed", !isSelected && !disabled && "hover:bg-hover-control")}>{option_0.label}{option_0.countLoading ? <motion.div className={badgeStyles({
              selected: !disabled && isSelected,
              disabled
            })}> </motion.div> : option_0.count != null ? <motion.div className={badgeStyles({
              selected: !disabled && isSelected,
              disabled
            })}>{option_0.count}{option_0.hasMore ? "+" : ""}</motion.div> : null}</motion.button>{isSelected && !disabled && <motion.div key={value} layoutId={groupId} transition={{
            duration: 0.12,
            type: "tween"
          }} className="absolute inset-0 bg-accent rounded-[calc(var(--filter-pill-radius)-3px)] select-none z-0" />}</div>;
      };
      $[10] = disabled;
      $[11] = getAnimate;
      $[12] = groupId;
      $[13] = onChange;
      $[14] = value;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = options.map(t3);
    $[3] = disabled;
    $[4] = getAnimate;
    $[5] = groupId;
    $[6] = onChange;
    $[7] = options;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[16] !== ariaLabel || $[17] !== disabled || $[18] !== t2) {
    t3 = <motion.div aria-label={ariaLabel} data-disabled={disabled} role="radiogroup" layout={true} layoutRoot={true} className="rounded-(--filter-pill-radius) border border-tertiary flex flex-row justify-center items-center gap-0.5 p-0.5 relative h-11 md:h-8">{t2}</motion.div>;
    $[16] = ariaLabel;
    $[17] = disabled;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  return t3;
};
export default ToggleGroup;